import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Separator as Separator_ } from '@root/shared/ui-kit'
import { Slider } from '@root/shared/ui-kit/slider'

import SLIDE_BANNER from '../assets/slide-banner.inline.svg?raw'
import SLIDE_COLOR from '../assets/slide-color.inline.svg?raw'
import SLIDE_LOGO from '../assets/slide-logo.inline.svg?raw'
import SLIDE_RAID from '../assets/slide-raid.inline.svg?raw'
import SLIDE_SPLASH from '../assets/slide-splash.inline.svg?raw'

import { PremiumSliderImage } from './premium-slider-image'

import type { ClassNameProps } from '@root/shared/lib/react'

type PremiumSliderProps = {} & ClassNameProps

export const PremiumSliderPaired: React.FC<PremiumSliderProps> = ({
  className,
}) => {
  const { t } = useTranslation()

  return (
    <Slider className={className}>
      <SlideGroup>
        <Slide>
          <SubTitle>{t('premium.slider.slide-color')}</SubTitle>
          <SlideImage svg={SLIDE_COLOR} />
        </Slide>
        <Separator vertical />
        <Slide>
          <SubTitle>{t('premium.slider.slide-logo')}</SubTitle>
          <SlideImageOffset svg={SLIDE_LOGO} />
        </Slide>
      </SlideGroup>
      <SlideGroup>
        <Slide>
          <SubTitle>{t('premium.slider.slide-banner')}</SubTitle>
          <SlideImage svg={SLIDE_BANNER} />
        </Slide>
        <Separator vertical />
        <Slide>
          <SubTitle>{t('premium.slider.slide-splash')}</SubTitle>
          <SlideImage svg={SLIDE_SPLASH} />
        </Slide>
      </SlideGroup>
      <SlideGroup>
        <Slide>
          <SubTitle>
            <Trans
              i18nKey="premium.slider.slide-raid"
              components={[<strong key={0} />, <br key={1} />]}
            />
          </SubTitle>
          <SlideImage svg={SLIDE_RAID} />
        </Slide>
        <Separator vertical />
        <Slide>
          <SubTitle>{t('premium.slider.slide-banner')}</SubTitle>
          <SlideImage svg={SLIDE_BANNER} />
        </Slide>
      </SlideGroup>
    </Slider>
  )
}

const SubTitle = styled.div`
  color: var(--slider-title-color, var(--text-8));

  text-align: center;
  font-style: normal;

  font-size: 12px;
  font-weight: var(--slider-title-weight, 400);
  line-height: 16px;
  width: 300px;
  margin: 0 auto;
  margin-bottom: -10px;
`

const SlideGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  align-items: center;
`

const Slide = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;

  align-items: center;
  justify-content: center;
`

const SlideImage = styled(PremiumSliderImage)`
  width: 80%;
`

const SlideImageOffset = styled(PremiumSliderImage)`
  margin-inline-start: 37px;
`

const Separator = styled(Separator_)`
  height: 70%;
`
